/**
 * 切换到第几个角色
 * @param index 第几个角色
 * @param tips
 */
import clickElement from "./click-element";
import {BATCH_TIPS_MODE} from '../../lib/constant';

export default function switchSprite({index, tips}, mode, _index) {
    //代码中通过mode是否为undefined来判断是否要显示聊天记录，因此这里不能初始化 if (mode === undefined) mode = stepsRuntime.mode;
    if (_index === undefined) _index = {stepIndex: stepsRuntime.stepIndex, actionIndex: stepsRuntime.actionIndex};
    //TODO 需要等待界面切换真正完成再返回。可以考虑在GUI的生命周期函数里发送消息来识别。实在不行，因为切换时会产生大量的blockly事件，可以通过判断无blockly事件的时间长度来判断。
    if (!tips) {
        tips = '点击这里切换到第' + (index + 1) + '个角色';
    }
    if (mode) {
        window.stepsRuntime.insertTips(_index, tips, true);
        if (mode === BATCH_TIPS_MODE) {
            return new Promise(resolve => {
                resolve();
            })
        }
    }
    return clickElement({
        element: 'div[class^="sprite-selector_sprite-wrapper"]',
        index,
        tips
    }).then(()=>{
        showMessage("角色切换中，请等待1秒钟再继续操作");
        return new Promise(resolve => {
            setTimeout(resolve, 1000);
        })
    });
}
